import { render, staticRenderFns } from "./NewFQCUser.vue?vue&type=template&id=7936d80a&scoped=true"
import script from "./NewFQCUser.vue?vue&type=script&lang=js"
export * from "./NewFQCUser.vue?vue&type=script&lang=js"
import style0 from "./NewFQCUser.vue?vue&type=style&index=0&id=7936d80a&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7936d80a",
  null
  
)

export default component.exports